// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header */
.navbar {
  flex-direction: column;
  padding: 0 !important;
}
@media (max-width: 1000px) {
  .navbar {
    flex-direction: row;
  }
}

.headerContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
  width: 100vw;
}
@media (max-width: 1000px) {
  .headerContainer {
    padding: 0 12px 0 12px;
  }
}

.navbar-brand {
  position: relative;
}

.navbar-custom {
  padding-left: 37px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.navbar-sl {
  background: #00061A;
}

.header-title {
  position: absolute;
  left: 36px;
  top: 0;
  font-family: Chakra Petch;
}

.heading {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: -1px;
  color: #ff6b00;
  margin-left: 3px;
}

.sub-heading {
  position: absolute;
  top: 25px;
  left: 3px;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}

.notification {
  padding: 0.75rem;
}

header .wallet-btn {
  padding: 8px 20px;
  /* margin-left: 30px; */
  margin-top: 10px;
  border-radius: 50px;
  color: #fff;
  font-size: 14px;
  background: #ff6b00;
  font-weight: 600;
}

.nav-link .wallet-adapter-button {
  background: #FFFFFF;
  border: none;
  box-sizing: border-box;
  box-shadow: inset 0px 2px px #FFFFFF, inset 0px -4px 4px rgba(0, 48, 73, 0.25), inset 0px 0px 25px #FFFFFF;
  border-radius: 8px;
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  font-size: 16px;
  padding: 10px 20px 10px 20px;
  height: unset;
  line-height: 22px;
  font-feature-settings: "pnum" on, "lnum" on;
  text-transform: uppercase;
  color: #003049;
}
.nav-link .wallet-adapter-button:hover {
  color: #48CAE4 !important;
  background: #FFFFFF !important;
}
@media (max-width: 1000px) {
  .nav-link .wallet-adapter-button {
    display: none;
  }
}

.wallet-adapter-modal-wrapper {
  background: rgba(20, 20, 20, 0.9) !important;
  border-radius: 12px !important;
}

.wallet-adapter-modal-title {
  font-family: Chakra Petch !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 32px !important;
}

.wallet-adapter-modal-list .wallet-adapter-button {
  background: rgba(196, 196, 196, 0.4) !important;
}

.wallet-adapter-modal-collapse-button {
  background: rgba(196, 196, 196, 0.4) !important;
}

header .wallet-adapter-button-start-icon {
  margin-left: 0px;
  width: 18px;
  height: 18px;
}

header .wallet-adapter-dropdown-list {
  display: grid;
  grid-row-gap: 4px;
  background: rgba(50, 50, 50, 0.7);
}

header .wallet-adapter-dropdown-list-item {
  background: rgba(255, 255, 255, 0.15);
}

@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) and (backdrop-filter: blur(30px)) {
  .wallet-adapter-modal-wrapper {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(196, 196, 196, 0.1) 100%) !important;
    box-shadow: inset 0px 4px 20px rgba(255, 255, 255, 0.25), inset 0px -4px 20px rgba(0, 0, 0, 0.25) !important;
    backdrop-filter: blur(30px) !important;
  }
}
.deckButtonSuccess {
  background: rgba(56, 196, 13, 0.6);
}

.deckButtonError {
  background: rgba(219, 3, 14, 0.6);
}

.headerLeftContainer .socialMediaBox {
  width: 32px;
  height: 32px;
  background: rgba(0, 48, 73, 0.75);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 24px;
  cursor: pointer;
}
@media (max-width: 1000px) {
  .headerLeftContainer .socialMediaBox {
    display: none;
  }
}

.socialMediaBox .socialMediaIcon {
  color: white;
  fill: white;
  width: 16px;
}

.socialMediaBox:hover .socialMediaIcon {
  fill: #48CAE4;
  color: #48CAE4;
}

.headerLeftContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1000px) {
  .headerLeftContainer {
    position: relative;
    z-index: 2000;
  }
}

.logoText {
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
  color: #FFFFFF;
  margin-left: 24px;
}
@media (max-width: 1000px) {
  .logoText {
    margin-left: 12px;
  }
}

.logoContainer {
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
}

.mobileRightContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1000px) {
  .mobileRightContainer {
    display: none;
  }
}

.mobileIcon {
  width: 36px;
  height: 36px;
  margin-left: 8px;
  position: relative;
  z-index: 2000;
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.scss"],"names":[],"mappings":"AAEA,WAAA;AACE;EACA,sBAAA;EACA,qBAAA;AADF;AAGE;EAJA;IAKC,mBAAA;EAAD;AACF;;AAGE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAAH;AACG;EARD;IASA,sBAAA;EAEA;AACF;;AAEE;EACD,kBAAA;AACD;;AAEE;EACD,kBAAA;EACA,oDAAA;AACD;;AAEE;EACD,mBAAA;AACD;;AAEE;EACD,kBAAA;EACA,UAAA;EACA,MAAA;EACA,yBAAA;AACD;;AAEE;EACD,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AACD;;AAEE;EACD,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;AACD;;AAEE;EACD,gBAAA;AACD;;AAEE;EACD,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AACD;;AAGE;EACD,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,0GAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,aAAA;EACA,iBAAA;EACA,2CAAA;EACA,yBAAA;EACA,cAAA;AAAD;AACC;EACC,yBAAA;EACA,8BAAA;AACF;AACC;EAtBC;IAuBA,aAAA;EAEA;AACF;;AAEE;EACD,4CAAA;EACA,8BAAA;AACD;;AAEE;EACD,oCAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;AACD;;AAEE;EACD,+CAAA;AACD;;AAEE;EACD,+CAAA;AACD;;AAEE;EACD,gBAAA;EACA,WAAA;EACA,YAAA;AACD;;AAEE;EACD,aAAA;EACA,iBAAA;EACA,iCAAA;AACD;;AAEE;EACD,qCAAA;AACD;;AAIA;EACC;IACC,0GAAA;IACA,4GAAA;IACA,sCAAA;EADA;AACF;AAME;EACD,kCAAA;AAJD;;AAOE;EACD,iCAAA;AAJD;;AAOE;EACD,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAJD;AAKC;EAVC;IAWA,aAAA;EAFA;AACF;;AAKE;EACD,YAAA;EACA,WAAA;EACA,WAAA;AAFD;;AAKE;EACD,aAAA;EACA,cAAA;AAFD;;AAKE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAFH;AAGG;EALD;IAMA,kBAAA;IACA,aAAA;EAAA;AACF;;AAIE;EACD,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AADD;AAEC;EARC;IASA,iBAAA;EACA;AACF;;AAEE;EACC,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACH;;AAEE;EACD,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACD;AAAC;EALC;IAMA,aAAA;EAGA;AACF;;AAAE;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAGH","sourcesContent":["\r\n\r\n/* Header */\r\n  .navbar {\r\n\t\tflex-direction: column;\r\n\t\tpadding: 0 !important;\r\n\r\n\t\t@media (max-width: 1000px) {\r\n\t\t\tflex-direction: row;\r\n\t\t  }\r\n  }\r\n\r\n  .headerContainer {\r\n\t  display: flex;\r\n\t  flex-direction: row;\r\n\t  justify-content: space-between;\r\n\t  align-items: center;\r\n\t  position: relative;\r\n\t  z-index: 1;\r\n\t  width: 100vw;\r\n\t  @media (max-width: 1000px) {\r\n\t\tpadding: 0 12px 0 12px;\r\n\t  }\r\n\r\n\t}\r\n  \r\n  .navbar-brand {\r\n\tposition: relative;\r\n  }\r\n  \r\n  .navbar-custom {\r\n\tpadding-left: 37px;\r\n\tfilter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\r\n  }\r\n  \r\n  .navbar-sl {\r\n\tbackground: #00061A;\r\n  }\r\n  \r\n  .header-title {\r\n\tposition: absolute;\r\n\tleft: 36px;\r\n\ttop: 0;\r\n\tfont-family: Chakra Petch;\r\n  }\r\n  \r\n  .heading {\r\n\tfont-style: normal;\r\n\tfont-weight: bold;\r\n\tfont-size: 18px;\r\n\tletter-spacing: -1px;\r\n\tcolor: #ff6b00;\r\n\tmargin-left: 3px;\r\n  }\r\n  \r\n  .sub-heading {\r\n\tposition: absolute;\r\n\ttop: 25px;\r\n\tleft: 3px;\r\n\tfont-size: 12px;\r\n\tline-height: 16px;\r\n\ttext-transform: uppercase;\r\n\tcolor: rgba(255, 255, 255, 0.5);\r\n  }\r\n  \r\n  .notification {\r\n\tpadding: 0.75rem;\r\n  }\r\n  \r\n  header .wallet-btn {\r\n\tpadding: 8px 20px;\r\n\t/* margin-left: 30px; */\r\n\tmargin-top: 10px;\r\n\tborder-radius: 50px;\r\n\tcolor: #fff;\r\n\tfont-size: 14px;\r\n\tbackground: #ff6b00;\r\n\tfont-weight: 600;\r\n  }\r\n\r\n  \r\n  .nav-link .wallet-adapter-button {\r\n\tbackground: #FFFFFF;\r\n\tborder: none;\r\n\tbox-sizing: border-box;\r\n\tbox-shadow: inset 0px 2px px #FFFFFF, inset 0px -4px 4px rgba(0, 48, 73, 0.25), inset 0px 0px 25px #FFFFFF;\r\n\tborder-radius: 8px;\r\n\tfont-family: Chakra Petch;\r\n\tfont-style: normal;\r\n\tfont-weight: bold;\r\n\tfont-size: 18px;\r\n\ttext-align: center;\r\n\tfont-size: 16px;\r\n\tpadding: 10px 20px 10px 20px;\r\n\theight: unset;\r\n\tline-height: 22px;\r\n\tfont-feature-settings: 'pnum' on, 'lnum' on;\r\n\ttext-transform: uppercase;\r\n\tcolor: #003049;\r\n\t&:hover {\r\n\t\tcolor: #48CAE4 !important;\r\n\t\tbackground: #FFFFFF !important;\r\n\t}\r\n\t@media (max-width: 1000px) {\r\n\t\tdisplay: none;\r\n\t  }\r\n\r\n  }\r\n  \r\n  .wallet-adapter-modal-wrapper {\r\n\tbackground: rgba(20, 20, 20, 0.9) !important;\r\n\tborder-radius: 12px !important;\r\n  }\r\n\r\n  .wallet-adapter-modal-title {\r\n\tfont-family: Chakra Petch !important;\r\n\tfont-style: normal !important;\r\n\tfont-weight: bold !important;\r\n\tfont-size: 32px !important;\r\n  }\r\n\r\n  .wallet-adapter-modal-list .wallet-adapter-button {\r\n\tbackground: rgba(196, 196, 196, 0.4) !important;\r\n  }\r\n\r\n  .wallet-adapter-modal-collapse-button {\r\n\tbackground: rgba(196, 196, 196, 0.4) !important;\r\n  }\r\n  \r\n  header .wallet-adapter-button-start-icon {\r\n\tmargin-left: 0px;\r\n\twidth: 18px;\r\n\theight: 18px;\r\n  }\r\n  \r\n  header .wallet-adapter-dropdown-list {\r\n\tdisplay: grid;\r\n\tgrid-row-gap: 4px;\r\n\tbackground: rgba(50,50,50,0.7);\r\n  }\r\n  \r\n  header .wallet-adapter-dropdown-list-item {\r\n\tbackground: rgba(255,255,255,0.15);\r\n  }\r\n\r\n\r\n\r\n@supports (((-webkit-backdrop-filter: none) or (backdrop-filter: none)) and (backdrop-filter: blur(30px)) ) {\r\n\t.wallet-adapter-modal-wrapper {\r\n\t\tbackground: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(196, 196, 196, 0.1) 100%) !important;\r\n\t\tbox-shadow: inset 0px 4px 20px rgba(255, 255, 255, 0.25), inset 0px -4px 20px rgba(0, 0, 0, 0.25) !important;\r\n\t\tbackdrop-filter: blur(30px) !important; \r\n\t}\r\n\r\n\r\n  }\r\n\r\n  .deckButtonSuccess {\r\n\tbackground: rgba(56, 196, 13, 0.6);\r\n  }\r\n\r\n  .deckButtonError{\r\n\tbackground: rgba(219, 3, 14, 0.6);\r\n  }\r\n\r\n  .headerLeftContainer .socialMediaBox {\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tbackground: rgba(0, 48, 73, 0.75);\r\n\tborder-radius: 5px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tmargin-left: 24px;\r\n\tcursor: pointer;\r\n\t@media (max-width: 1000px) {\r\n\t\tdisplay: none;\r\n\t}\r\n  }\r\n\r\n  .socialMediaBox .socialMediaIcon {\r\n\tcolor: white;\r\n\tfill: white;\r\n\twidth: 16px;\r\n  }\r\n\r\n  .socialMediaBox:hover .socialMediaIcon {\r\n\tfill: #48CAE4;\r\n\tcolor: #48CAE4;\r\n  }\r\n\r\n  .headerLeftContainer {\r\n\t  display: flex;\r\n\t  flex-direction: row;\r\n\t  justify-content: center;\r\n\t  align-items: center;\r\n\t  @media (max-width: 1000px) {\r\n\t\tposition: relative;\r\n\t\tz-index: 2000;\r\n\t}\r\n\t  \r\n  }\r\n\r\n  .logoText {\r\n\tfont-family: Chakra Petch;\r\n\tfont-style: normal;\r\n\tfont-weight: bold;\r\n\tfont-size: 20px;\r\n\tline-height: 26px;\r\n\tcolor: #FFFFFF;\r\n\tmargin-left: 24px;\r\n\t@media (max-width: 1000px) {\r\n\t\tmargin-left: 12px;\r\n\t}\r\n  }\r\n\r\n  .logoContainer {\r\n\t  cursor: pointer;\r\n\t  justify-content: center;\r\n\t  align-items: center;\r\n\t  display: flex;\r\n  }\r\n\r\n  .mobileRightContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\t@media (min-width: 1000px) {\r\n\t\tdisplay: none;\r\n\t}\r\n  }\r\n\r\n  .mobileIcon {\r\n\t  width: 36px;\r\n\t  height: 36px;\r\n\t  margin-left: 8px;\r\n\t  position: relative;\r\n\t  z-index: 2000;\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
